var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"goBack"},[_c('div',{staticClass:"flex goBack"},[_c('span',{staticClass:"back",on:{"click":_vm.goBack}},[_vm._v(" 返回 ")]),_vm._v(" "),_c('h2',{staticClass:"backTitle"},[_vm._v(" "+_vm._s(this.subTitle)+" ")]),_vm._v(" "),_c('i',{staticClass:"none"})])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-229c61d8","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/header/components/GoBack.vue
// module id = null
// module chunks = 